/**
 * Implements functionality for buttons that the user can use to clear selected filters in faceted
 * search.
 */
(() => {
    let form = document.querySelector('.js-faceted-search-form');

    if (!form) {
        return;
    }

    function clearKeyword(button, name) {
        let input = form.querySelector("input[name='" + name + "']");

        if (!input) {
            return;
        }

        input.value = input.value
            .replaceAll(button.getAttribute('data-value'), '')
            .trim()
            .replaceAll('  ', ' ')
            .replaceAll('  ', ' ');
        // input.focus();
        form.dispatchEvent(new Event('input'));

        // button.style.visibility = 'hidden';
    }

    function clearCheckbox(button, name) {
        const value = button.getAttribute('data-value');

        if (!value) {
            return;
        }

        let input = form.querySelector(
            "input[type=checkbox][name='" + name + "'][value='" + value + "']"
        );

        if (!input) {
            return;
        }

        input.checked = false;
        // input.focus();
        input.dispatchEvent(new Event('change'));
        form.dispatchEvent(new Event('input'));

        // button.style.visibility = 'hidden';
    }

    function onClick(e) {
        // console.log('Button was pressed');
        e.preventDefault();

        let button = e.currentTarget.closest('.js-faceted-search-clear-button');

        const name = button.getAttribute('data-name');

        if (!name) {
            return;
        }

        if (name === faceted_search.text_query_name) {
            clearKeyword(button, name);
        } else {
            clearCheckbox(button, name);
        }
        H_Tools?.search?.showResults();
    }

    function clearAll(e) {
        // console.log('Clear all button pressed...');

        e.preventDefault();

        document
            .querySelectorAll(
                '.js-faceted-search-filters input:is([type=checkbox], input[type=radio])'
            )
            .forEach((input) => {
                input.checked = false;
                input.dispatchEvent(new Event('change'));
            });

        let field = document.querySelector('.js-faceted-search-text-field');
        if (field) {
            field.value = '';
        }

        form.dispatchEvent(new Event('input'));
        H_Tools?.search?.showResults();
    }

    function addListeners() {
        // "Clear all" listener
        document
            .querySelector('.js-faceted-search-clear-all-button')
            ?.addEventListener('click', clearAll);

        const buttons = document.querySelectorAll(
            '.js-faceted-search-clear-button'
        );

        if (!buttons.length) {
            return;
        }

        buttons.forEach((button) => {
            button.addEventListener('click', onClick);
        });
    }

    form.addEventListener('htmx:afterSettle', (e) => {
        addListeners();
    });

    addListeners();
})();
